import { getNestedPropertyOrDefault } from 'style-utils/core/createExtractCssFromProps/utils/getNestedPropertyOrDefault';

export const positiveOrNegative = (scale: any, value: any) => {
  if (typeof value !== 'number' || value >= 0) {
    return getNestedPropertyOrDefault(scale, value, value);
  }
  const absolute = Math.abs(value);
  const n = getNestedPropertyOrDefault(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};
